const { makeStyles } = require("@mui/styles");

const useStyles = makeStyles({
  outer: { display: "flex", flexDirection: "column", position: "relative" },
  camera_view: { width: "100%", minWidth: 250, maxWidth: 250, borderRadius: 5, height: 187 },
  capture_button: {
    position: "absolute",
    right: 5,
    bottom: 0,
    border: "none",
    background: "white",
    cursor: "pointer",
    borderRadius: "100%",
    padding: "4px",
    height: "45px",
    width: "45px",
    border: "1px solid",
    bottom: 5,
  },
  image_view: { width: "100%", minWidth: 250, maxWidth: 250, borderRadius: 5, height: 187 },
});

export default useStyles;
